import { PropsWithChildren } from "react";
import { Autoplay, EffectFade } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import useKioskSliderImages from "./useKioskSliderImages";

type KioskBackgroundSliderProps = PropsWithChildren<{
  overlayClassName?: string;
}>;

const KioskBackgroundSlider = ({ children, overlayClassName }: KioskBackgroundSliderProps) => {
  const sliderImages = useKioskSliderImages();

  return (
    <div className="h-screen w-full overflow-hidden">
      <div className="relative h-full w-full bg-black">
        <Swiper
          modules={[Autoplay, EffectFade]}
          loop
          effect="fade"
          fadeEffect={{ crossFade: true }}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          allowTouchMove={false}
          className="absolute inset-0 h-full w-full"
        >
          {sliderImages.map((image) => (
            <SwiperSlide key={image}>
              <div
                className="h-full w-full bg-center bg-cover"
                style={{ backgroundImage: `url(${image})` }}
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <div
          className={
            overlayClassName ??
            "absolute inset-0 z-10 bg-[linear-gradient(to_bottom,rgba(0,0,0,0.35),rgba(0,0,0,0.72))]"
          }
        />

        <div
          className="absolute inset-0 flex h-full flex-col items-center justify-center p-10"
          style={{ zIndex: 50 }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default KioskBackgroundSlider;
